// extracted by mini-css-extract-plugin
export default {"title":"reminders_title__TleKN","text":"reminders_text__mdRs3","icon":"reminders_icon__FWc9C","button":"reminders_button__kLryq"};